document.addEventListener("DOMContentLoaded", function () {
    const dialogs = document.querySelectorAll(".dialog");

    dialogs?.forEach((dialog) => {
        const buttonClose = dialog.querySelector(".dialog__close");
        buttonClose.addEventListener("click", () => dialog.close());
    });
});
